export default {
	TOKEN_KEY: "token",
	TOKEN_EXPIRED_KEY: "token-expired",
	USER_KEY: "user",
	AUTH_DATA: "AuthData",
	HOOK_STORAGE_KEYS: {
		USER_DATA: "UserData",
		AUTH_DATA: "AuthData",
		LANGUAGE_DATA: "LanguageData",
		ADMIN_DATA: "AdminData",
		Issuance_DATA: "IssuanceData"
	},
	sizes: {
		mobile: 767
	},
	CORE_URLS: {
		LAUNCH: "/launches",
		NOT_FOUND: "/404",
		ADMIN_AUTH: "/admin/auth"
	},
	GLOBAL_CONSTANTS: {
		ENV_STAGE: import.meta.env.VITE_ENV_STAGE,
		LOCAL_STORAGE_PREFIX: import.meta.env.VITE_LOCAL_STORAGE_PREFIX,
		DOCUMENTATION_LINK: import.meta.env.VITE_DOCUMENTATION_LINK,
		SOCIAL_X_LINK: import.meta.env.VITE_SOCIAL_X_LINK,
		SOCIAL_FACEBOOK_LINK: import.meta.env.VITE_SOCIAL_FACEBOOK_LINK,
		SUPPORT_EMAIL: import.meta.env.VITE_SUPPORT_EMAIL,
		MARKET_API: import.meta.env.VITE_MARKET_API,
		MARKET_API_KEY: import.meta.env.VITE_MARKET_API_KEY,
		AZURE_STORAGE_URL: import.meta.env.VITE_AZURE_STORAGE_URL,
		TERMS_OF_USE: import.meta.env.VITE_TERMS_OF_USE
	}
};
